import { MSG_NETWORK_ERR } from '../enum/env'

/**
 * 检查响应结果是否出错，有错则提示
 * @param {Object | null} res 返回的结果
 * @param {number} successCode 正确的code
 * @returns {boolean} 有错返回true;否则返回false
 */
function checkResponseIsErr(res, successCode = 0) {
  const message = this?.$message || window?.app?.$message

  if (!res) {
    // 请求错误
    message && message?.error(MSG_NETWORK_ERR)
    return true
  } else if (res?.code !== successCode) {
    // 返回的code错误
    message && message?.error(res?.msg || MSG_NETWORK_ERR)
    return true
  }

  return false
}

const mixinCheckResponseIsErr = {
  methods: {
    checkResponseIsErr
  }
}

export { mixinCheckResponseIsErr, checkResponseIsErr }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/mixin/request.js